import moment from 'moment'

export const reportSalesPeriod = {
    startDate : moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    customerId: ''
}

export const reportPurchasePeriod = {
    startDate : moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    supplierId: ''
}

export const reportDailyMutation = {
    startDate : moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    productId: ''
}
